import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchRecommendedItems, setWidgetBoxTitle } from 'features/recommendedItems/slice';

function useWidget ({ schemeName, onLoad }) {

	const dispatch = useDispatch();
	const recommendedItems = useSelector((state) => state.recommendedItems);
	const widget = recommendedItems.Widgets[schemeName] || {};
	const loaded = recommendedItems.fetchStatus === 'fulfilled';

	// Recommended Items comes from 1 call fo a whole page, based on window.resx
	// If the widget isn't found, it hasn't been fetched, or isn't setup by the resx
	useEffect(() => {

		if (!loaded) {

			dispatch(fetchRecommendedItems());

		}

	}, [ dispatch, loaded ]);

	const runOnLoad = useCallback(() => {

		if (onLoad) {

			onLoad(widget);

		}

	}, [ onLoad, widget ]);

	useEffect(() => {

		if (loaded) {

			runOnLoad();

		}

	}, [ loaded, runOnLoad ]);

	const updateWidgetBoxTitle = (title) => {

		dispatch(setWidgetBoxTitle({ schemeName, title }));

	};

	return {
		loaded,
		updateWidgetBoxTitle,
		widget
	};

}

export default useWidget;
